import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for animating Highlight Component when it comes into view
 */
export default class HighlightComponent extends MessageBus {
  /**
   * @param {HTMLElement} element - The highlight-component container
   */
  constructor(element) {
    super();
    this.element = element;
    this.scrollRaf = null;
    this.isAlreadyAnimated = false;

    this.init();
  }

  init() {
    this.cacheDomReferences().setupHandlers().enable();
    return this;
  }

  cacheDomReferences() {
    this.wrapper = this.element.querySelector(
      `.${CLASS_NAMES.HIGHLIGHT_COMPONENT_WRAPPER}`
    );
    return this;
  }

  setupHandlers() {
    this.onScroll = this.onScroll.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    return this;
  }

  enable() {
    window.addEventListener(EVENTS.SCROLL, this.onScroll);
    this.onScroll();
    return this;
  }

  destroy() {
    window.removeEventListener(EVENTS.SCROLL, this.onScroll);
    if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
  }

  onScroll() {
    if (this.scrollRaf) return;
    this.scrollRaf = requestAnimationFrame(this.handleScroll);
  }

  handleScroll() {
    this.scrollRaf = null;
    if (this.isAlreadyAnimated) return;

    const rect = this.element.getBoundingClientRect();
    const inView = rect.top + 300 < window.innerHeight && rect.bottom > 0;

    if (!inView) return;

    this.wrapper.classList.add(CLASS_NAMES.IS_IN_VIEWPORT);
    this.isAlreadyAnimated = true;
  }
}
